@if (product) {
  <div class="product-order-item--grid-item">
    <div class="product-order-item__row">
      <div class="product-order-item--header grid-item">
        <div>
          <div class="header--row">
            <div class="image">
              <app-image-container
                [attr.id]="'product-image-' + product.id"
                [image]="imageUrl"
                type="product"
                class="clickable"
                [recommended]="isProductRecommended"
                [featured]="showFeaturedTag ? product.isFeatured : false"
                [priorityItem]="
                  showFeaturedTag ? product.isPriorityItem : false
                "
                [isCancelled]="product.isCancelled"
                (click)="onImageClicked()"
              ></app-image-container>
              @if (!isShopHidden) {
                <button
                  [attr.id]="'quick-shop-btn-' + product.id"
                  class="btn btn-primary btn--quick-shop"
                  (click)="shopProduct()"
                  [disabled]="!canBuyProduct"
                >
                  {{ shopLabel }}
                </button>
              }
            </div>
            <div class="description">
              <div class="description__body">
                <div class="text-align-start">
                  <app-product-flag-container
                    [product]="product"
                  ></app-product-flag-container>
                  <span class="font-5 color--primary-grey"
                    >SKU #:
                    {{ product.firstSku?.getDisplaySkuID() || '' }}</span
                  >
                  <a
                    [attr.id]="'product-name-link-' + product.id"
                    routerLink="{{ product.productURL }}"
                    class="link color--primary-grey product--description__label"
                  >
                    <span
                      class="font-4 text-capitalize"
                      [innerHTML]="product.label | safeContent"
                    ></span>
                  </a>
                  <div class="d-flex align-items-center justify-content-start">
                    @if (canSeeFavorites) {
                      <button
                        class="btn btn-icon me-2"
                        (click)="toggleFavorites()"
                        [disabled]="updatingFavorites"
                        title="{{
                          hasFavorites
                            ? 'Remove from Favorites'
                            : 'Add to Favorites'
                        }}"
                      >
                        @if (updatingFavorites !== true && hasFavorites) {
                          <i class="fas fa-heart color-red"></i>
                        }
                        @if (updatingFavorites !== true && !hasFavorites) {
                          <i class="fal fa-heart"></i>
                        }
                        @if (updatingFavorites === true) {
                          <i class="fal fa-sync rotate"></i>
                        }
                      </button>
                    }
                    @for (type of product.sustainability; track $index) {
                      <app-product-sustainable-item
                        [sustainableType]="type"
                      ></app-product-sustainable-item>
                    }
                  </div>
                </div>
                @if (product.getProgram()) {
                  <h6
                    class="product-program color--primary-blue text-align-start"
                    [innerHTML]="product.getProgram() | safeContent"
                  ></h6>
                }
              </div>
            </div>
          </div>
          <!--price-->
          <div class="header--row subheader">
            <app-product-order-item-price
              [attr.id]="'product-price-' + product.id"
              [orderItem]="orderItem"
              [product]="product"
              viewType="grid-item"
              fontSize="font-4"
            >
            </app-product-order-item-price>
            @if (isProductRecommended) {
              <app-product-recommened-quantity
                view="grid"
                [recommendedQty]="product.recommended_qty_expected"
                [currentQty]="product.recommended_qty_current"
              ></app-product-recommened-quantity>
            }
            <!--min order-->
            @if (showMinOrder) {
              <app-product-order-item-min-max
                class="mt-2"
                [orderItem]="orderItem"
                [showGroupedMaxQuantity]="true"
                [headerPosition]="true"
                [isRecommended]="isProductRecommended"
                [product]="product"
                viewType="grid-item"
                fontSize="font-6"
              ></app-product-order-item-min-max>
            }
            <!--in stock-->
            @if (!product.isBuyingWindow) {
              <app-product-order-item-in-stock
                [showCombinedQuantity]="product.hasVariations"
                [sku]="variationSKU"
                [orderItemId]="orderItem?.id"
                [product]="product"
                [quantity]="orderedQuantity"
                fontSize="font-6"
                viewType="grid-item"
              ></app-product-order-item-in-stock>
            }
          </div>
          @if (discontinued) {
            <div>
              <span class="d-block text-align-center font-4 fw-bold"
                >Discontinued</span
              >
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
